import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🇬🇧',
    title: 'pages.onboarding.languages.en',
    value: 'en',
  },
  {
    emoji: '🇪🇸',
    title: 'pages.onboarding.languages.es',
    value: 'es',
  },
  {
    emoji: '🇩🇪',
    title: 'pages.onboarding.languages.de',
    value: 'de',
  },
  {
    emoji: '🇫🇷',
    title: 'pages.onboarding.languages.fr',
    value: 'fr',
  },
  {
    emoji: '🇮🇹',
    title: 'pages.onboarding.languages.it',
    value: 'it',
  },
  {
    emoji: '🇵🇹',
    title: 'pages.onboarding.languages.pt',
    value: 'pt',
  },
  {
    emoji: '🇳🇱',
    title: 'pages.onboarding.languages.nl',
    value: 'nl',
  },
  {
    emoji: '🇯🇵',
    title: 'pages.onboarding.languages.ja',
    value: 'ja',
  },
  {
    emoji: '🇨🇳',
    title: 'pages.onboarding.languages.ch',
    value: 'zh',
  },
  {
    emoji: '🇰🇷',
    title: 'pages.onboarding.languages.ko',
    value: 'ko',
  },
  {
    emoji: '🇷🇺',
    title: 'pages.onboarding.languages.ru',
    value: 'ru',
  },
  {
    emoji: '🇮🇩',
    title: 'pages.onboarding.languages.in',
    value: 'id',
  },
  {
    emoji: '🇵🇱',
    title: 'pages.onboarding.languages.pl',
    value: 'pl',
  },
  {
    emoji: '🇸🇪',
    title: 'pages.onboarding.languages.sv',
    value: 'sv',
  },
  {
    emoji: '🇹🇷',
    title: 'pages.onboarding.languages.tr',
    value: 'tr',
  },
]

export default function LanguageQuestionPage() {
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    const selectedLanguage = event.currentTarget.value as string

    if (selectedLanguage) {
      localStorage.setItem('selectedLanguage', selectedLanguage)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.languageQuestion.title"
      withLogin
      onSubmit={handleSubmit}
    />
  )
}
